import { render, staticRenderFns } from "./CodigoPerfilAgenteField.vue?vue&type=template&id=5a5c4697&scoped=true&"
import script from "./CodigoPerfilAgenteField.vue?vue&type=script&lang=js&"
export * from "./CodigoPerfilAgenteField.vue?vue&type=script&lang=js&"
import style0 from "./CodigoPerfilAgenteField.vue?vue&type=style&index=0&id=5a5c4697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c4697",
  null
  
)

export default component.exports